module.exports = __webpack_public_path__ + "img/dalou_bg_png.3f6655bf.png";